import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { SIDE_NAV_WIDTH, SideNav } from 'components/SideNav/SideNav';

const VerticalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%',
});

const ContentWrapper = styled('div')({
  flex: 1,
  padding: '24px',
  overflow: 'auto',
});

interface VerticalLayoutProps {
  children?: ReactNode;
}

export const VerticalLayout: FC<VerticalLayoutProps> = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F9FAFB' }}>
      <SideNav />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          marginLeft: `${SIDE_NAV_WIDTH}px`,
          transition: 'margin-left 0.3s ease',
        }}
      >
        <VerticalLayoutContainer>
          <ContentWrapper className="content">
            <Outlet />
          </ContentWrapper>
        </VerticalLayoutContainer>
      </Box>
    </Box>
  );
};
